import { createQueryString } from '~/domains/common/utils/queryString';

import {
  MissionStatus,
  type GetMissionsParams,
  type MissionsResponse,
  type MissionDetailResponse,
} from '../types/missions.types';

import { missionsInstance } from './missions.instance';

export const getMissions = async ({
  status = MissionStatus.STARTED,
  offset = 0,
  limit = 20,
  location,
}: GetMissionsParams): Promise<MissionsResponse> => {
  const queryString = createQueryString({ status, offset, limit, location });
  const response = await missionsInstance.get(`/missions${queryString}`);

  return response.data;
};

export const getMissionDetail = async (assignmentId: string): Promise<MissionDetailResponse> => {
  const response = await missionsInstance.get(`/missions/${assignmentId}`);

  return response.data;
};

/**
 * Marks the completion modal as seen for a completed mission assignment.
 * Idempotent on the server (204). Callers should treat failures as non-fatal.
 */
export const markMissionCompletionSeen = async (assignmentId: string): Promise<void> => {
  await missionsInstance.post(`/missions/${assignmentId}/seen`);
};
